import { Field, FormDataType } from "../types/index";

function isZeroAllowed(field: Field, value: unknown) {
  return (
    field.inputType === "number" && value === 0 && (field.minValue ?? 0) <= 0
  );
}

export const validateFormFields = (
  fields: Field[],
  formValues: FormDataType
) => {
  fields.forEach((field) => {
    if (!formValues[field.fieldName] && field.isRequired) {
      if (isZeroAllowed(field, formValues[field.fieldName])) return;
      throw new Error(`${field.fieldName} cannot be empty`);
    }
  });

  const hasPasswordConfirmationField = fields.some(
    (field) => field.fieldName === "passwordConfirmation"
  );

  if (hasPasswordConfirmationField) {
    if (formValues["passwordConfirmation"] !== formValues["password"]) {
      throw new Error("Passwords do not match.");
    }
  }
};
